import { APIEvent } from '../events/apiEvent'
import { StatusBarEvent } from '../events/statusBarEvent'
import { EventBus } from '../event-bus'
import { JSONToCSVConvertor, createReportLabel } from '../utils'
import { CUSTOMER_LABEL } from '../constants/customerEvents/customerEventLabels'
export default {

  data: function () {
    return {
      deviceList: [],
      startOffset: 0,
      currentPage: 1,
      hasNextPage: false,
      requestData: null,
      perPage: 20,
      pageNumber: 1,
      searchString: '',
      searchDeviceID: '',
      typeSelection: null,
      tenantSelection: null,
      errorMessage: '',
      searchType: 'last_name',
      pageOptions: [
        {text: 5, value: 5},
        {text: 10, value: 10},
        {text: 20, value: 20},
        {text: 50, value: 50},
        {text: 100, value: 100},
        {text: 200, value: 200}
      ],
      fields: {
        leakbot_id: {
          label: 'LeakBot ID',
          sortable: false
        },
        device_name: {
          label: 'Sigfox ID',
          sortable: false
        },
        serial_number: {
          label: 'Serial Number',
          sortable: false
        },
        first_name: {
          label: 'First Name',
          sortable: false
        },
        last_name: {
          label: 'Last name',
          sortable: false
        },
        username: {
          label: 'Email address',
          sortable: false
        },
        tenant_name: {
          label: 'Tenant',
          sortable: false
        },
        removed_date: {
          label: 'Date Removed',
          sortable: false
        }
      }
    }
  },
  computed: {
    tenants () {
      return this.$store.state.tenantsList.data
    }
  },
  mounted () {
    if (window.localStorage.getItem('token') === null) {
      this.$store.dispatch(APIEvent.LOGOUT, {})
    } else {
      this.fetchLeakListData()
    }
  },
  methods: {
    fetchLeakListData (offset, data) {
      data = data || {}
      data.start_offset = this.startOffset.toString()
      data.fetch_size = this.perPage
      if (this.tenantSelection !== null) {
        data.tenant_name = this.tenantSelection.name
      }

      if (this.searchString.trim() !== '') {
        data[this.searchType] = this.searchString
      }

      this.requestData = data
      this.$store.dispatch(APIEvent.FETCH_REMOVED_DEVICES_LIST, data)
        .then(this.fetchLeakListResponseHandler)
        .catch(this.handleError)
    },
    fetchLeakListResponseHandler (res) {
      var records = res.data.list.records
      if (!records) return
      if (this.download) {
        this.downloadHandler(records)
        // should we continue to display the data here?
        // return
      }
      for (var i = 0; i < records.length; i++) {
        var record = records[i]
        if (record.isVIP === '1') {
          record._rowVariant = 'danger'
        }
      }
      this.pageNumber = (this.startOffset / this.perPage) + 1
      this.deviceList = records
      this.$store.commit('SET_LEAKLIST', records)
      this.hasNextPage = res.data.LastPage === '0'
    },
    handleError (error) {
      let message = error.message
      switch (error.error) {
        case 209:
          message = 'Device ID is not in the expected format'
          break
        case 305:
          message = 'No matches found'
          break
        case 507:
          message = 'You are not permitted to view the customer profile'
          break
        case 511:
          message = 'Device ID has not been paired with a registered customer account'
          break
      }
      error.message = message
      EventBus.$emit(StatusBarEvent.ERROR, error.message)
    },

    search () {
      if (!this.download) {
        this.resetTable()
      }
      let startOffset = this.startOffset
      let searchString = this.searchDeviceID
      let tenantName = this.tenantSelection === null ? '' : this.tenantSelection.name

      if (searchString !== '') {
        this.$store.dispatch(APIEvent.SEARCH, {searchType: 'LeakBotId', searchString})
          .then(() => {
            this.sanitiseSearchData({startOffset, tenantName})
          })
          .catch(this.handleError)
      } else {
        this.sanitiseSearchData({startOffset, tenantName})
      }
    },
    getSearchProp (propName) {
      let props = {
        startOffset: 'start_offset',
        tenantName: 'tenant_name'
      }
      let retValue = props[propName]
      if (props[propName] !== undefined) { return retValue || propName }
    },
    sanitiseSearchData (options) {
      options.id = (typeof options.id !== 'undefined') ? options.id : ''
      let data = {}
      for (var prop in options) {
        if (typeof options[prop] !== 'undefined' && options[prop] !== '') {
          data[this.getSearchProp(prop)] = options[prop].toString()
        }
      }

      data.fetch_size = this.perPage.toString()
      this.deviceList = []
      this.fetchLeakListData(this.startOffset, data)
    },
    page (event) {
      var next = event.currentTarget.className.indexOf('next') > -1
      if (next) {
        this.startOffset += this.perPage
      } else {
        this.startOffset -= this.perPage
      }
      this.fetchLeakListData(this.startOffset, this.requestData)
    },
    translate (value) {
      let translations = {
        'null': '',
        'LeakingToilet': 'Leaking toilet',
        'DrippingTap': 'Dripping tap',
        'Noneofthese': 'None of these',
        'GetHelp': 'Get help',
        'FixMyself': 'Fix myself',
        'AllFixed': 'All fixed',
        'CustomerRepaired': 'Customer repaired'
      }
      return typeof translations[value] === 'undefined'
        ? value
        : translations[value]
    },
    actionTranslation: function (value) {
      return CUSTOMER_LABEL[value]
    },
    nullFormatter: function (value) {
      return value === 'NA' ? '-' : value
    },
    resetTable () {
      this.download = false
      this.perPage = 20
      this.startOffset = 0
      this.hasNextPage = false
      this.pageNumber = 1
      this.errorMessage = ''
    },
    downloadReport () {
      // This will get the first 200 from the leak list
      this.download = true
      this.perPage = 200
      // pass the current start offset so entire records
      // can be manually downloaded
      this.search()
      // This just exports current data in view
      // this.downloadHandler(this.deviceList)
    },
    downloadHandler (records) {
      var headings = {
        leakbot_id: 'LeakBot ID',
        device_name: 'Sigfox ID',
        serial_number: 'Serial Number',
        first_name: 'First Name',
        last_name: 'Last Name',
        username: 'Email Address',
        tenant_name: 'Tenant',
        removed_date: 'Date Removed'
      }
      this.perPage = 20
      this.download = false
      var JsonData = JSON.stringify(records)
      if (JsonData !== '') {
        var title = createReportLabel('Removed Devices List')
        JSONToCSVConvertor(JsonData, title, true, headings)
      }
    }
  }
}
